import React from 'react'
import { AnnouncementDetailFormStyle } from './styled'
import {
  Button,
  Image,
  Input,
  Section,
  TextEditor,
  DatePickerInput,
} from '../../components'
import { ICONS, CONTENTS } from '../../themes'

import { ROUTE_PATH, redirect, STRING, getCroppedImg } from '../../helpers'

import Cropper from 'react-easy-crop'
import { Slider } from '@material-ui/core'

export class AnnouncementDetailFormContainer extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      isEditPageState: false,
      startDate: undefined,
      endDate: undefined,
    }
  }

  onChange(content) {
    console.log('onChange', content)
  }

  toggleModal = id => {
    this.setState(
      prevState => ({
        ...prevState,
        modals: prevState.modals.map(modal => ({
          ...modal,
          isOpen: modal.name === id ? !modal.isOpen : false,
        })),
      })
      // () => {
      //   console.log(this.state.modals)
      // }
    )
  }

  setStartDate = date => {
    this.setState({
      startDate: date,
    })
  }

  setEndDate = date => {
    this.setState({
      endDate: date,
    })
  }

  render() {
    const { isEditPageState, startDate, endDate } = this.state

    return (
      <React.Fragment>
        <AnnouncementDetailFormStyle>
          {/* PAGE TITLE
          -----------------------------------------------------
          -----------------------------------------------------
          */}
          <Section className="page-topbar">
            <Section className="page-header">
              <Section className="page-icon">
                <Image
                  id="page_icon_sustainability_pre_assessment_management"
                  src={ICONS['icon-speaker-white.svg']}
                  alt="page icon"
                />
              </Section>

              <Section className="title-and-breadcrumb">
                <Section
                  id="page_title_announcement_management"
                  className="title"
                >
                  {STRING.ANNOUNCEMENT_MANAGEMENT}
                </Section>

                <Section
                  id="page_breadcrumb_announcement_management"
                  className="breadcrumbs"
                >
                  <Button
                    className="breadcrumb"
                    onClick={() => {
                      this.props.history.push(ROUTE_PATH.HOME.LINK)
                    }}
                  >
                    <span>{STRING.HOME}</span>
                  </Button>

                  <Button
                    className="breadcrumb"
                    onClick={() => {
                      this.props.history.push(ROUTE_PATH.HOME.LINK)
                    }}
                  >
                    <span>{STRING.ANNOUNCEMENT_MANAGEMENT}</span>
                  </Button>

                  <Button className="breadcrumb current">
                    <span>
                      {isEditPageState
                        ? 'Edit Announcement'
                        : 'Create Announcement'}
                    </span>
                  </Button>
                </Section>
              </Section>
            </Section>
          </Section>

          {/* PAGE CONTENT
          -----------------------------------------------------
          -----------------------------------------------------
          */}
          <Section className="main-content form">
            <Section className="content-body">
              <Section className="form-wrapper">
                <Section className="form-group-title">
                  {isEditPageState
                    ? 'Edit Announcement'
                    : 'Create Announcement'}
                </Section>

                <Section className="form-group">
                  <Section className="form-group-control">
                    <Section className="form-group-inner-wrapper">
                      <Input type="text" />
                    </Section>

                    <Section className="message"></Section>
                  </Section>
                </Section>

                <Section className="form-group select-time">
                  <label>Announced date from</label>

                  <Section className="form-group-control">
                    <Section className="form-group-inner-wrapper">
                      <DatePickerInput
                        selected={startDate}
                        onChange={date => this.setStartDate(date)}
                        selectsStart
                        startDate={startDate}
                        endDate={endDate}
                        showTimeSelect
                        showMonthDropdown
                        showYearDropdown
                        isClearable
                        dateFormat="MMMM d, yyyy hh:mm aa"
                        timeIntervals={1}
                        dropdownMode="select"
                      />

                      <div className="conjunction">to</div>

                      <DatePickerInput
                        selected={endDate}
                        onChange={date => this.setEndDate(date)}
                        selectsEnd
                        startDate={startDate}
                        endDate={endDate}
                        minDate={startDate}
                        showTimeSelect
                        showMonthDropdown
                        showYearDropdown
                        isClearable
                        dateFormat="MMMM d, yyyy hh:mm aa"
                        timeIntervals={1}
                        dropdownMode="select"
                      />
                    </Section>

                    <Section className="message"></Section>
                  </Section>
                </Section>

                <Section>
                  <TextEditor
                    value="Default value"
                    options={{
                      lang: 'th-TH',
                      height: 350,
                      dialogsInBody: true,
                      toolbar: [
                        ['style', ['style']],
                        ['font', ['bold', 'underline', 'clear']],
                        ['fontname', ['fontname']],
                        ['color', ['color']],
                        ['para', ['ul', 'ol', 'paragraph']],
                        ['table', ['table']],
                        ['insert', ['link', 'picture', 'video']],
                        ['view', ['fullscreen', 'codeview', 'help']],
                      ],
                    }}
                    onChange={this.onChange}
                  />
                </Section>
              </Section>

              <Section className="form-actions">
                <Button className="theme-border-gray">Cancel</Button>

                <Button className="theme-green">Save</Button>
              </Section>
            </Section>
          </Section>
        </AnnouncementDetailFormStyle>
      </React.Fragment>
    )
  }
}
